import * as React from "react";
import {cx} from "emotion";

import "./line-items.scss";

import {cs}               from "@Common/react/chain-services";
import {scopedState}      from "@Common/react/scoped-state";
import {scn}              from "@Common/react/state-change-nested-value";
import {Select}           from "@Common/ui-components/heavy/common/design2/select/select";
import {SliderCheckbox}   from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {chain}            from "@Common/utils/fs";

import {getLineItemsFromMethod} from "../../../common/line-items-modules/line-items-logic";

export const lineItems = ({componentState, templateOptions}) => cs(
    ["method", (_, next) => next(componentState.value?.selections?.distributionType)],
    ["lineItems", ({method}, next) => next(getLineItemsFromMethod({method, templateOptions}).filter((lineItem) => lineItem.isUi))],
    ["optionsState", (_, next) => next(scopedState(componentState, ['selections', 'options'] ))],
    ({lineItems, optionsState}) => lineItems.length > 0 && (
        <div className={cx("line-items", "line-items-4ro")}>
            {lineItems
                .map((lineItem) => (
                    <div className="card" key={lineItem.dev_key}>
                        {lineItem.isRequired ? (
                            <div className="radio" xd-qa-type="icon" xd-qa-name={lineItem.name}>
                                <i className="fa fa-check"/>
                            </div>
                        ) : (
                            <div className="radio">
                                {SliderCheckbox({
                                    value: lineItemSelected({value: optionsState.value, dev_key: lineItem?.dev_key}),
                                    onChange: (o) => optionsState.change((currentState) =>
                                        lineItemSelected({value: currentState, dev_key: lineItem?.dev_key}) ? (
                                            [...currentState.filter((opt) => opt?.dev_key !== lineItem?.dev_key)]
                                        ) : (
                                            [...currentState, {
                                                dev_key: lineItem?.dev_key,
                                                subOptionDevKey: lineItem.showSubOptions && lineItem.subOptions && lineItem.subOptions[0]?.dev_key,
                                                group: 'lineItem'
                                            }]
                                        )
                                    ),
                                    xdQaName: lineItem.name,
                                })}
                            </div>
                        )}

                        <div className="text">
                            <div className="label" xd-qa-type="label" xd-qa-name={lineItem.name}>
                                {lineItem.name}{" "}
                                {/* {cs(
                                    () => lineItem.isRequired && lineItem.showSubOptions && state.onChange([...state.value, {
                                        dev_key: lineItem.dev_key,
                                        subOptionDevKey: lineItem.subOptions[0].dev_key,
                                    }]),
                                )} */}
                            </div>
                            <div className="description" xd-qa-type="label" xd-qa-name="description label">
                                {lineItem.description}
                            </div>
                            {lineItem.showSubOptions && (lineItem?.subOptions?.length === 1 ? (
                                <div className="sub-options-label" xd-qa-type="label" xd-qa-name={lineItem.subOptions && lineItem.subOptions[0].name}>
                                    {lineItem.subOptions && lineItem.subOptions[0].name}
                                </div>
                            ) : (
                                lineItem.subOptions && (lineItem.isRequired || lineItemSelected({value: optionsState.value, dev_key: lineItem.dev_key})) && <div className="sub-options">
                                    {SubOptionsDropdown({
                                        list: lineItem.subOptions,
                                        state: optionsState.value,
                                        dev_key: lineItem.dev_key,
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            }
        </div>
    ),
);

const SubOptionsDropdown = ({list, state, dev_key}) => Select({
    list,
    itemToLabel: (i) => i.name,
    isSelected: (i) => state.value.find((l) => l.dev_key === dev_key && l.subOptionDevKey === i.dev_key),
    onChange: (i) => {
        scn(state, [], (_) => chain(
            _,
            (_) => _.filter((opt) => opt.dev_key !== dev_key),
            (_) => [..._, {
                dev_key,
                subOptionDevKey: i.dev_key,
                group: 'lineItem'
            }],
        ))
    },
    forcedExpandLeft: true,
    placeholder: "Select...",
    xdQaName: "Sub Options",
})

const lineItemSelected = ({value, dev_key}) => {
    return !!value?.find((l) => dev_key === l?.dev_key)
};
